import _functionCall from "../internals/function-call";
import _anObject from "../internals/an-object";
import _isCallable from "../internals/is-callable";
import _classofRaw from "../internals/classof-raw";
import _regexpExec from "../internals/regexp-exec";
var exports = {};
var call = _functionCall;
var anObject = _anObject;
var isCallable = _isCallable;
var classof = _classofRaw;
var regexpExec = _regexpExec;
var $TypeError = TypeError;

// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
exports = function (R, S) {
  var exec = R.exec;
  if (isCallable(exec)) {
    var result = call(exec, R, S);
    if (result !== null) anObject(result);
    return result;
  }
  if (classof(R) === "RegExp") return call(regexpExec, R, S);
  throw new $TypeError("RegExp#exec called on incompatible receiver");
};
export default exports;